import Model from "./Model";

export default class ComponentParameters extends Model {

	constructor(props) {

		super({});

		this.setDefaultValues({
			component: {
				parameters: []
			},
			dataset: {
				parameters: []
			},
		}, props);
	}
}
